import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import Loader from './Loader';
import {useQuery} from '../utils';

const PARAMS = {
  'FP_DEV': {
    scriptId: 19917108677,
    cloudUrl: 'https://us-central1-dev-form-publisher.cloudfunctions.net/pickedFileOrFolder'
  },
  'FP_STAGING': {
    scriptId: 810586556449,
    cloudUrl: 'TBD'
  },
  'FP_PROD': {
    scriptId: 827172627657,
    cloudUrl: 'https://us-central1-form-publisher.cloudfunctions.net/pickedFileOrFolder'
  }
};

const useQueryParams = () => {
  const query = useQuery();
  const addonCode = query.get('addonCode');
  const accessToken = query.get('accessToken');
  const target = query.get('target');
  const documentId = query.get('documentId');
  const views = query.get('views')

  return [addonCode, accessToken, target, documentId, views];
};

function pickerCallback(data, {
  url,
  accessToken,
  target,
  documentId
}) {
  if (data.action === 'picked') {
    fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'post',
      body: JSON.stringify({
        data: {
          action: data.action,
          elements: data.docs.map(el => ({
            id: el.id,
            mimeType: el.mimeType,
            url: el.url,
          })),
          accessToken,
          target,
          documentId
        }
      })
    })
    .catch(console.error)
    .finally(() => {
      setTimeout(() => {
        window.parent.postMessage(data, '*');
      }, 500)
    });
  } else {
    window.parent.postMessage(data, '*');
  }
}

const PickerWrappepr = styled.div`
  min-width: 100%;
  min-height: 100%;
`;

const Picker = () => {
  const [addonCode, accessToken, target, documentId, views] = useQueryParams();
  const [pickerLoaded, setPickerLoaded] = useState(false);

  useEffect(() => {
    if (addonCode && PARAMS[addonCode] && accessToken) {
      /*global gapi*/
      gapi.load('picker', () => {
        /*global google*/
        const picker = new google.picker.PickerBuilder()
          .setAppId(PARAMS[addonCode].scriptId)
          .setOAuthToken(accessToken)
          .setCallback((data) => {
            setPickerLoaded(true);
            pickerCallback(data, {
              url: PARAMS[addonCode].cloudUrl,
              accessToken,
              target,
              documentId
            });
          })
          .setSize(window.innerWidth, window.innerHeight)
          .setOrigin(window.location.protocol + '//' + window.location.host);

        JSON.parse(views).forEach(view => {
  				if (view === 'FOLDERS') {
  					picker.addView(
  						new google.picker.DocsView(google.picker.ViewId.FOLDERS)
    						.setIncludeFolders(true)
    						.setSelectFolderEnabled(true)
  					)
  				} else {
  					picker.addView(google.picker.ViewId[view])
  				}
  			});

        picker.build().setVisible(true);
      });
    }
  }, []);

  return (<PickerWrappepr>
    {!pickerLoaded && <Loader width="100px" height="100px" />}
  </PickerWrappepr>);
}

export default Picker;
